export const VERSION = "v3.1.65";
export const EXT_TITLE = "Webint Center";